<template>
	<div class="idx_wrap clearfix">
		<div class="workbench">
			<div class="card">
				<div class="card-header" style="background: none; font-size: 20px; font-weight: bold;">控制台</div>
				<div class="card-body">
					<!-- 1 -->
					<div class="clearfix">
						<div class="row">
							<div class="col">
								<!-- 注册统计 -->
								<div class="card mr-2">
									<div class="card-header">
										<span class="float-left">注册统计</span>
										<router-link :to="{name: 'client_statistics'}" class="float-right">查看</router-link>
									</div>
									<div class="card-body" style="padding: 1.25rem 0;">
										<div class="d-flex bd-highlight text-center" style="height: 120px;">
											<div class="flex-fill bd-highlight" style="border-right: 1px solid rgba(0,0,0,.125);">
												<div>昨日客户数</div>
												<h3 class="mt-4">{{yesterday}}</h3>
											</div>
											<div class="flex-fill bd-highlight" style="border-right: 1px solid rgba(0,0,0,.125);">
												<div>今日客户数</div>
												<h3 class="mt-4">{{today}}</h3>
											</div>
											<div class="flex-fill bd-highlight">
												<div>客户总数</div>
												<h3 class="mt-4">{{total}}</h3>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col">
								<!-- 财务统计 -->
								<div class="card">
									<div class="card-header">
										<span class="float-left">财务统计</span>
										<router-link :to="{name: 'finance_stats'}" class="float-right">查看</router-link>
									</div>
									<div class="card-body" style="padding: 1.25rem 0;">
										<div class="d-flex bd-highlight text-center" style="height: 120px;">
											<div class="flex-fill bd-highlight" style="border-right: 1px solid rgba(0,0,0,.125);">
												<div>月收入</div>
												<h3 class="mt-4">{{incomeMonth}}</h3>
											</div>
											<div class="flex-fill bd-highlight" style="border-right: 1px solid rgba(0,0,0,.125);">
												<div>本年度收入</div>
												<h3 class="mt-4">{{incomeYear}}</h3>
											</div>
											<div class="flex-fill bd-highlight">
												<div>总收入</div>
												<h3 class="mt-4">{{incomeTotal}}</h3>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 2 -->

					<!-- 用户列表 -->
					<div class="demo-block">
						<el-table :data="CustomerList" style="width: 100%">
							<el-table-column label="头像" align="center">
								<template slot-scope="scope">
									<div class="demo-basic--circle">
										<div class="block"><el-avatar :size="40" :src="scope.row.avatar==''?'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png':scope.row.avatar"></el-avatar></div>
									  </div>
								</template>
							</el-table-column>
							<el-table-column label="用户名" align="center">
								<template slot-scope="scope">
									<div>{{ scope.row.username }}</div>
								</template>
							</el-table-column>
							<el-table-column label="地区" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row.city==''?'暂无':scope.row.city }}</span>
								</template>
							</el-table-column>
							<el-table-column label="注册时间" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row.regist_date}}</span>
								</template>
							</el-table-column>
							<el-table-column label="会员到期时间" min-width="100%" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row.vip_text }}</span>
								</template>
							</el-table-column>
							<el-table-column label="总消费金额" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row.total_consume }}</span>
								</template>
							</el-table-column>
							<el-table-column label="分成比例" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row.divide_ratio }}</span>
								</template>
							</el-table-column>
							<el-table-column label="赏金" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row.reward }}</span>
								</template>
							</el-table-column>
					
						</el-table>
					</div>
					<!-- 用户列表 -->
				</div>
			</div>
			<!-- 分页 -->
			<!-- <div class="workbench_paging clearfix">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
				 :page-sizes="pageSizes" :page-size="pageSize" :total="help_num" layout="total, sizes, prev, pager, next, jumper">
				</el-pagination>
			</div> -->
			
			<pading :help="help_num" :currentPage = "currentPage" :pageSize="pageSize" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pading>
			</div>
			<!-- 分页 -->
			
		</div>
	</div>
</template>

<script>
	import { StatisticsNum, FinancialStat, CustomerList } from '../../common/api/http.js'
	import Pading from '../../components/paging/index.vue' //分页组件
	export default {
		components:{
			Pading
		},
		data() {
			return {
				
				yesterday:'',//	昨日注册数
				today:'', //今日注册数
				total:'', //总注册数
				
				incomeMonth:'',//月收入
				incomeYear:'',//年收入
				incomeTotal:'',//总收入
				
				CustomerList: [], //客户列表
				
				help_num: 1, //总共多少条内容 默认1
				currentPage:1, //当前页的index
				pageSize:10, //每页显示多少条
			}
		},
		mounted() {
			
			// 注册统计
			let token = window.sessionStorage.getItem('token')
			
			let data = {
				'api_token':token,
			}
			StatisticsNum(data).then(res => {
				// console.log(res)
				if(res.code == 0){
					this.yesterday = res.data.yesterday
					this.today = res.data.today
					this.total = res.data.total
				}else{
					this.$message.error(res.msg);
				}
				
			}).catch(err => {
				console.log(err)
			})
			// 注册统计
			
			// 收入统计
			FinancialStat(data).then(res => {
				// console.log(res)
				if(res.code == 0){
					this.incomeMonth = res.data.month//月收入
					this.incomeYear = res.data.year//年收入
					this.incomeTotal = res.data.total//总收入
				}else{
					this.$message.error(res.msg);
				}
				
			}).catch(err => {
				console.log(err)
			})
			// 收入统计
			
			// 客户列表
			this.clientList()
			// 客户列表
		},
		methods: {
			// 每页显示条数 10，20，50，100
			handleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.pageSize = val
				this.clientList()
			},
			//当前页的index
			handleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.currentPage = val
				this.clientList()
			},
			// 客户列表
			clientList(){
				let token = window.sessionStorage.getItem('token')
				let customerData = {
					'api_token':token,
					'page':this.currentPage,
					'page_size':this.pageSize
				}
				CustomerList(customerData).then(res => {
					// console.log(res)
					if(res.code == 0){
						this.CustomerList = res.data.customer_list
						
						this.help_num = parseInt(res.data.total)
					}else{
						this.$message.error(res.msg);
					}
					
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	.idx_wrap {
		margin-top: 20px;
	}

	.demo-block {
		margin-top: 40px;
		border: 1px solid #ebebeb;
		border-radius: 3px;
	}
	.workbench_paging {
		margin-top: 40px; margin-bottom: 30px;
		.el-pagination {
			float: right;
		}
	}
</style>
